/**
 * Indicate if the header should have fill color or if should be transparent on page load
 * Need to be rewritten to non-js
 */
function pageHeaderDetection() {
    // find the first section
    const firstSection = document.getElementById('section-number-1');
    // check if it has background color or background image
    const hasBgColor = firstSection.classList.contains('section--bg-color');
    const hasBgImg = firstSection.classList.contains('section--bg-img');
    const hasPageHeader = firstSection.classList.contains('s-page-header');
    const hasPageHeaderSimple = firstSection.classList.contains('s-page-header-simple');

    // keep the site header transparent
    if (hasBgColor || hasBgImg || hasPageHeader || hasPageHeaderSimple) {
        return;
    }

    // make site header white
    /* TODO: replace .js-no-page-header class with something js-header-white or js-header-fill-color */
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('js-no-page-header');
}
window.addEventListener('load', function () {
    pageHeaderDetection();
    document.body.classList.remove('preload');
    /* get all section with background color */
    const bgColorSections = document.querySelectorAll('.section--bg-color');

    /* do something with each found section */
    bgColorSections.forEach(function (section) {
        const sectionBgColor = window.getComputedStyle(section).getPropertyValue('background-color'),
            prevSection = section.previousElementSibling,
            nextSection = section.nextElementSibling;

        let prevSectionBgColor = null,
            nextSectionBgColor = null;

        if (prevSection !== null) {
            prevSectionBgColor = window.getComputedStyle(prevSection).getPropertyValue('background-color');
        }

        if (nextSection !== null) {
            nextSectionBgColor = window.getComputedStyle(nextSection).getPropertyValue('background-color');
        }

        /* if the current section has the same background color as prev section,
            reduce its top padding */
        if (null !== prevSection && sectionBgColor === prevSectionBgColor) {
            /* console.log('a section with bg-color before'); */
            section.classList.add('section--top-p-small');
        }

        /* if the current section has the same background color as next section,
            reduce its bottom padding */
        if (null !== nextSection && sectionBgColor === nextSectionBgColor) {
            /* console.log('a section with bg-color after'); */
            section.classList.add('section--bottom-p-small');
        }
    });
});

require('./routes/other/animations');



// WEBPACK FOOTER //
// ./scripts/critical.js